import { render, staticRenderFns } from "./tableChannelsDiff.vue?vue&type=template&id=7657aa60&scoped=true"
import script from "./tableChannelsDiff.vue?vue&type=script&lang=js"
export * from "./tableChannelsDiff.vue?vue&type=script&lang=js"
import style0 from "./tableChannelsDiff.vue?vue&type=style&index=0&id=7657aa60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7657aa60",
  null
  
)

export default component.exports